// extracted by mini-css-extract-plugin
export default {"title":"NotificationForm_title__AdesL","sectionTitle":"NotificationForm_sectionTitle__01OJs","buttonArea":"NotificationForm_buttonArea__InQAE"};